export const CART_PRODUCT_IMAGE_WIDTHS = {
  product: "115px",
  gap: "20px",
  brand: "30px",
  manufacturer: "22px",
};
